import { merge } from 'lodash';

import { fields } from '../../../../../forms/user';
import BaseModel from '../common/BaseModel';

const model = merge({}, BaseModel, {
  template: {
    header: {
      showBack: true,
    },
  },
  headerBlock: {
    title: 'Enter the code we just sent to your phone',
    progressBar: {
      progress: 100,
      withContainer: true,
    },
    subtitle: ['Account', '100% complete'],
  },
  info: {
    title: 'Verify one-time password',
    subtitle: 'Help',
    content: [
      {
        copy: [
          "Your one-time password is an autogenerated code that's good for a single login and used to verify your identity. You should receive this token by email or SMS and will be required to enter it into the sign in form to access your account. If for some reason you did not receive a code, review the phone number provided or click " +
            '"re-send".',
        ],
      },
    ],
  },
  form: {
    actions: {
      primary: {
        testId: 'verify',
        label: 'Verify',
      },

      secondary: {
        label: 'Re-send',
        testId: 'resend',
      },
    },
    fields: {
      pin: {
        testId: 'pin',
        ...fields.pin,
      },
    },
  },
  resendTimerDuration: 15,
});
export default model;
